export default {
  segment_labels: {
    active: 'Ativos',
    cancelled: 'Cancelados',
    completed: 'Concluídos',
  },
};
